/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ManagedServiceName,
  ManagedServiceName$inboundSchema,
  ManagedServiceName$outboundSchema,
} from "./managedservicename.js";
import {
  ManagedServiceStatus,
  ManagedServiceStatus$inboundSchema,
  ManagedServiceStatus$outboundSchema,
} from "./managedservicestatus.js";

export type ManagedServiceRecord = {
  name: ManagedServiceName;
  containerPort: number;
  assignmentGeneration: number;
  status?: ManagedServiceStatus | undefined;
  failureReason?: string | null | undefined;
};

/** @internal */
export const ManagedServiceRecord$inboundSchema: z.ZodType<
  ManagedServiceRecord,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: ManagedServiceName$inboundSchema,
  container_port: z.number().int(),
  assignment_generation: z.number().int(),
  status: ManagedServiceStatus$inboundSchema.optional(),
  failure_reason: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "container_port": "containerPort",
    "assignment_generation": "assignmentGeneration",
    "failure_reason": "failureReason",
  });
});
/** @internal */
export type ManagedServiceRecord$Outbound = {
  name: string;
  container_port: number;
  assignment_generation: number;
  status?: string | undefined;
  failure_reason?: string | null | undefined;
};

/** @internal */
export const ManagedServiceRecord$outboundSchema: z.ZodType<
  ManagedServiceRecord$Outbound,
  z.ZodTypeDef,
  ManagedServiceRecord
> = z.object({
  name: ManagedServiceName$outboundSchema,
  containerPort: z.number().int(),
  assignmentGeneration: z.number().int(),
  status: ManagedServiceStatus$outboundSchema.optional(),
  failureReason: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    containerPort: "container_port",
    assignmentGeneration: "assignment_generation",
    failureReason: "failure_reason",
  });
});

export function managedServiceRecordToJSON(
  managedServiceRecord: ManagedServiceRecord,
): string {
  return JSON.stringify(
    ManagedServiceRecord$outboundSchema.parse(managedServiceRecord),
  );
}
export function managedServiceRecordFromJSON(
  jsonString: string,
): SafeParseResult<ManagedServiceRecord, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ManagedServiceRecord$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ManagedServiceRecord' from JSON`,
  );
}
